export default __webpack_public_path__ + "static/media/logo_heisei_car_rentals.e05eddcf.svg";